import P from 'prop-types';
import { useEffect, useState } from 'react';
import { Api } from '../../../services/api';

export const CargasAtribuidas = ({ id }) => {
  const [myCargas, setMyCargas] = useState(null);
  const [isLoadingCarga, setLoadingCarga] = useState(true);

  const searchCargas = async () => {
    try {
      const objs = await Api.post('/carga/', { token: id });

      setMyCargas(objs.data);
      console.log('Cargas:');
      console.log(objs.data);
    } catch (e) {
      setMyCargas(null);
    } finally {
      setLoadingCarga(false);
    }
  };

  useEffect(() => {
    searchCargas();
  }, [id]);

  return (
    <>
      <h5>Cargas Atribuídas</h5>
      <ul className="list-group list-group-flush">
        {isLoadingCarga ? (
          <>
            <div className="placeholder-glow">
              <span className="placeholder w-100"></span>
            </div>
            <div className="placeholder-glow">
              <span className="placeholder w-100"></span>
            </div>
            <div className="placeholder-glow">
              <span className="placeholder w-100"></span>
            </div>
            <div className="placeholder-glow">
              <span className="placeholder w-100"></span>
            </div>
          </>
        ) : myCargas && myCargas.length > 0 ? (
          myCargas.map((obj) => (
            <li key={obj.id} className="list-group-item">
              #{obj.cod_carga} - {obj.nome_cliente}
            </li>
          ))
        ) : (
          <div>Ainda não foi atribuida nenhuma carga a esse token</div>
        )}
      </ul>
    </>
  );
};

CargasAtribuidas.propTypes = {
  id: P.number,
};
